import { Box, Button, Dropdown, DropdownOption } from "@modernatx-internal/component-library";
import { useRouter } from "next/router";
import React from "react";

import { ContentComponentProps, FinderFormContent } from "../types";

type FinderFormComponentProps = ContentComponentProps<FinderFormContent>;

export const PrefectureFinderForm: React.FC<FinderFormComponentProps> = ({
  buttonLabel,
  dropdownLabel,
  errorMessage: errorMessageProp,
  prefectureList,
  redirectPath
}) => {
  const router = useRouter();

  const [selectedPrefecture, selectedPrefectureSet] = React.useState<DropdownOption | undefined>();
  const [isError, isErrorSet] = React.useState(false);

  const errorMessage = React.useMemo(
    () => (isError ? errorMessageProp : undefined),
    [isError, errorMessageProp]
  );

  const handleSelect = React.useCallback(
    (option: DropdownOption) => {
      isErrorSet(false);
      selectedPrefectureSet(option);
    },
    [isErrorSet, selectedPrefectureSet]
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedPrefecture) {
      isErrorSet(true);
      return;
    } else {
      const queryParams = new URLSearchParams({ prefecture: String(selectedPrefecture.value) });
      router.push(`${redirectPath}?${queryParams.toString()}`);
    }
  };

  return (
    <Box
      as="form"
      sx={{ display: "flex", flexDirection: "column", gap: 6, alignItems: "center" }}
      onSubmit={handleSubmit}
    >
      <Dropdown
        sx={{ alignSelf: "stretch" }}
        label={dropdownLabel}
        dropdownOptions={prefectureList}
        error={errorMessage}
        required={true}
        selectedOption={selectedPrefecture}
        onSelectOption={handleSelect}
      />
      <Box>
        <Button
          variant="critical"
          sx={{ backgroundColor: "color-current-brand-secondary-600", px: 16 }}
          type="submit"
        >
          {buttonLabel}
        </Button>
      </Box>
    </Box>
  );
};
